(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["register"]) return;
  try {
    
    $(function(){
      const clssBtnRegister = '.form-submit';
    
      checkTerm();
      $(document).on('change', 'input[name="term_check"]', function() {
        checkTerm()
      });

      function checkTerm() {
        if($('input[name="term_check"]').is(':checked')) {
          $(clssBtnRegister).prop('disabled', false)
        } else {
          $(clssBtnRegister).prop('disabled', true)
        }
      }

      function getAddInfo() {
        let first_name_kana = $('input[name="customer[note][first_name_kana]"]');
        let last_name_kana = $('input[name="customer[note][last_name_kana]"]');
        let gender = $('input[name="customer[note][gender]"]:checked');
        let birth_year = $('select[name="customer[note][birth_year]"] option:selected');
        let birth_month = $('select[name="customer[note][birth_month]"] option:selected');
        let birth_day = $('select[name="customer[note][birth_day]"] option:selected');

        return {
          first_name_kana: first_name_kana.val(),
          last_name_kana: last_name_kana.val(),
          gender: gender.val(),
          birth_year: birth_year.val(),
          birth_month: birth_month.val(),
          birth_day: birth_day.val(),
        }
      }

      function updateTagsCustomer() {
  
        let data = getAddInfo();
        let keys = Object.keys(data);
        let html = '';
        for(const prop in data) {
          html+= prop +':\''+ data[prop] + '\',';
        }
  
        let inputData = $('#create_customer input[name="customer[tags][info]"]');
        inputData.val(html.replace(/\,$/, ''));
      }

      $('#create_customer').on('submit', function(e) {
        updateTagsCustomer();
        return true;
      });

      $(document).on('blur', 'input[type="text"], input[type="tel"], input[type="email"], input[type="password"], input[type="radio"], select', function() {
        updateTagsCustomer();
      })
    })

  } catch(e) { console.error(e); }
})();
})();
